"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Grid = _interopRequireDefault(require("../Grid"));
var _Heading = _interopRequireDefault(require("../Heading"));
var _Text = _interopRequireDefault(require("../Text"));
var _Tick = _interopRequireDefault(require("../../icons/Tick"));
var _theme = _interopRequireDefault(require("../../theme"));
var _styledComponents = require("./styled-components");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); } // @ts-ignore
function Hero(props) {
  var headline = props.headline,
    subtitle = props.subtitle,
    children = props.children,
    checkList = props.checkList,
    _props$swishColor = props.swishColor,
    swishColor = _props$swishColor === void 0 ? 'white' : _props$swishColor,
    _props$swishDisplay = props.swishDisplay,
    swishDisplay = _props$swishDisplay === void 0 ? 'full' : _props$swishDisplay,
    _props$solidBackgroun = props.solidBackgroundColor,
    solidBackgroundColor = _props$solidBackgroun === void 0 ? null : _props$solidBackgroun,
    illustration = props.illustration,
    _props$illustrationWi = props.illustrationWidth,
    illustrationWidth = _props$illustrationWi === void 0 ? 500 : _props$illustrationWi,
    _props$illustrationHe = props.illustrationHeight,
    illustrationHeight = _props$illustrationHe === void 0 ? 500 : _props$illustrationHe,
    _props$illustrationAl = props.illustrationAlt,
    illustrationAlt = _props$illustrationAl === void 0 ? 'Hero Illustration' : _props$illustrationAl,
    _props$illustrationSr = props.illustrationSrcType,
    illustrationSrcType = _props$illustrationSr === void 0 ? 'image/png' : _props$illustrationSr,
    _props$illustrationSr2 = props.illustrationSrcset,
    illustrationSrcset = _props$illustrationSr2 === void 0 ? '' : _props$illustrationSr2,
    _props$illustrationMe = props.illustrationMedia,
    illustrationMedia = _props$illustrationMe === void 0 ? '' : _props$illustrationMe,
    _props$illustrationSi = props.illustrationSizes,
    illustrationSizes = _props$illustrationSi === void 0 ? '' : _props$illustrationSi;
  var swishColorEncoded = encodeURI(swishColor).replace('#', '%23');
  var hasChildren = !!children;
  function getIllustrationComponent(isSmallViewport) {
    if (!illustration) {
      return null;
    }
    return /*#__PURE__*/_react["default"].createElement(_styledComponents.Illustration, {
      isSmallViewport: isSmallViewport
    }, /*#__PURE__*/_react["default"].createElement(_styledComponents.IllustrationPicture, {
      imageWidth: illustrationWidth,
      imageHeight: illustrationHeight
    }, /*#__PURE__*/_react["default"].createElement("source", {
      srcSet: illustrationSrcset,
      sizes: illustrationSizes,
      media: illustrationMedia,
      type: illustrationSrcType
    }), /*#__PURE__*/_react["default"].createElement(_styledComponents.IllustrationImage, {
      src: illustration,
      alt: illustrationAlt
    })));
  }
  return /*#__PURE__*/_react["default"].createElement(_styledComponents.HeroContainer, _extends({
    swishColorEncoded: swishColorEncoded,
    noIllustration: !illustration,
    noSwish: swishDisplay === 'none',
    solidBackgroundColor: solidBackgroundColor
  }, props), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
    style: {
      gridGap: _theme["default"].space10
    }
  }, /*#__PURE__*/_react["default"].createElement(_styledComponents.ContentWrapper, {
    noIllustration: !illustration,
    noSwish: swishDisplay === 'none'
  }, /*#__PURE__*/_react["default"].createElement(_Heading["default"], {
    variant: "140",
    color: "white"
  }, headline), subtitle ? /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    variant: "140",
    color: "white"
  }, subtitle) : null, getIllustrationComponent(true), hasChildren ? /*#__PURE__*/_react["default"].createElement(_styledComponents.ChildrenWrapper, null, children) : null, checkList ? /*#__PURE__*/_react["default"].createElement(_styledComponents.ChecklistWrapper, null, checkList.map(function (element, index) {
    return /*#__PURE__*/_react["default"].createElement(_styledComponents.CheckListItemWrapper, {
      key: index
    }, /*#__PURE__*/_react["default"].createElement(_Tick["default"], {
      color: "white",
      size: hasChildren ? 8 : 16,
      title: "Tick icon for check list item position ".concat(index + 1),
      "aria-hidden": true
    }), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
      variant: hasChildren ? '100' : '140',
      color: "white"
    }, element));
  })) : null), getIllustrationComponent(false)));
}
Hero.propTypes = {
  headline: _propTypes["default"].string.isRequired,
  checkList: _propTypes["default"].arrayOf(_propTypes["default"].string),
  subtitle: _propTypes["default"].string,
  children: _propTypes["default"].node,
  swishColor: _propTypes["default"].string,
  swishDisplay: _propTypes["default"].oneOf(['full', 'none']),
  solidBackgroundColor: _propTypes["default"].string,
  illustration: _propTypes["default"].string,
  illustrationWidth: _propTypes["default"].number,
  illustrationHeight: _propTypes["default"].number,
  illustrationAlt: _propTypes["default"].string,
  illustrationSrcset: _propTypes["default"].string,
  illustrationSizes: _propTypes["default"].string,
  illustrationMedia: _propTypes["default"].string,
  illustrationSrcType: _propTypes["default"].string
};
var _default = exports["default"] = Hero;